module.exports = __webpack_public_path__ + "static/img/feature-shape-1.5420bb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/interthings/feature-shape-1.png
// module id = 5/7P
// module chunks = 4